/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, ContentChild, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { AddListComponent } from '../add-list/add-list.component';
import { MasterChildViewComponent } from './master-child-view.component';

@Component({
	selector: 'master-child',
	templateUrl: './master-child.component.html',
	styleUrls: ['./master-child.component.scss'],
	standalone: false,
})
export class MasterChildComponent implements OnInit {
	//An optional input for you to include to set if the child component is displayed in the same row as the master component.
	@Input() displayChildInRow = true;
	//An optional input for you to override the width given to the master component.
	@Input() masterWidth = 50;
	//An optional input for you to override the width given to the child component.
	@Input() childWidth = 50;
	// An optional input for you to override if the master component has a filter.
	@Input() hasFilterContent = false;
	// An optional input for you to override if the master component has a matcard.
	@Input() masterDisplayedInMatCard = true;
	// An optional input for you to override if the child component has a matcard.
	@Input() childDisplayedInMatCard = true;
	// An optional input for you to override if the master component filter has a title.
	@Input() filterTitle = '';

	@ContentChild(AddListComponent, { static: true }) master: AddListComponent;
	@ContentChild(MasterChildViewComponent, { static: true }) child: MasterChildViewComponent;
	@Output() itemDeleted = new EventEmitter<Object>();

	private ngUnsubscribe: Subject<boolean> = new Subject();
	selectedRowId: number = null;

	ngOnInit(): void {
		this.master.selectedRowChanged.subscribe((params) => {
			this.rowChanged(params);
		});

		this.child.itemDeleted.subscribe((params) => {
			this.master.itemDeleted.emit();
		});

		this.filterTitle = this.filterTitle;
	}

	get hasTitle(): boolean {
		return this.filterTitle !== null && this.filterTitle !== undefined && this.filterTitle !== '';
	}

	rowChanged(params: any) {
		this.selectedRowId = params?.id;
		this.child.masterRowData = params;
		this.child.MasterRowChanged();
	}

	ngAfterViewInit() {}

	ngOnDestroy() {
		this.ngUnsubscribe.next(true);
		this.ngUnsubscribe.complete();
	}

	get masterHeight() {
		if (this.hasFilterContent) {
			return 'has-filter';
		}
		return 'no-filter';
	}

	//These getter methods return strings for flex classes in the custom-flex-box.scss,
	//all these percentage classes are set up for whole numbers 1-100 but for other percentage values or pixel values
	//you will need to check a flex class exists for the width you are trying to apply.
	//suffix your input with 'px' to apply pixel based widths
	get masterWidthClass() {
		return `flex-${this.masterWidth}`;
	}
	get childWidthClass() {
		return `flex-${this.childWidth}`;
	}
}
